import api from "./api";
import {
  ApiResponse,
  Workshop,
  WorkshopCreateDTO,
  WorkshopFoto,
  WorkshopFotoCreateDTO,
  WorkshopUpdateDTO,
} from "./types";

export const BirlikteGuzellestirelimService = {
  workshopListele: async () => {
    const response = await api.get<ApiResponse<Workshop[]>>(
      "/api/BirlikteGuzellestirelim/WorkshopListele"
    );
    return response.data;
  },

  workshopDetay: async (id: string) => {
    const response = await api.get<ApiResponse<Workshop>>(
      `/api/BirlikteGuzellestirelim/WorkshopDetay/${id}`
    );
    return response.data;
  },

  workshopEkle: async (data: WorkshopCreateDTO) => {
    const formData = new FormData();
    formData.append("baslik", data.baslik);
    formData.append("aciklama", data.aciklama);
    formData.append("workshopYil", data.workshopYil);
    if (data.kapakFotoFile) {
      formData.append("kapakFotoFile", data.kapakFotoFile);
    }
    if (data.yatayFotoFile) {
      formData.append("yatayFotoFile", data.yatayFotoFile);
    }

    const response = await api.post<ApiResponse<Workshop>>(
      "/api/BirlikteGuzellestirelim/WorkshopEkle",
      formData,
      {
        headers: { "Content-Type": "multipart/form-data" },
      }
    );
    return response.data;
  },

  workshopGuncelle: async (data: WorkshopUpdateDTO) => {
    const formData = new FormData();
    formData.append("id", data.id);
    formData.append("baslik", data.baslik);
    formData.append("aciklama", data.aciklama);
    formData.append("workshopYil", data.workshopYil);
    formData.append("kapakGorsel", data.kapakGorsel || "");
    formData.append("yatayGorsel", data.yatayGorsel || "");
    formData.append("workshopFotolar", JSON.stringify([]));

    if (data.kapakFotoFile) {
      formData.append("kapakFotoFile", data.kapakFotoFile);
    }
    if (data.yatayFotoFile) {
      formData.append("yatayFotoFile", data.yatayFotoFile);
    }

    const response = await api.put<ApiResponse<Workshop>>(
      "/api/BirlikteGuzellestirelim/WorkshopGuncelle",
      formData,
      {
        headers: { "Content-Type": "multipart/form-data" },
      }
    );
    return response.data;
  },

  workshopSil: async (id: string) => {
    const response = await api.delete<ApiResponse<boolean>>(
      `/api/BirlikteGuzellestirelim/WorkshopSil/${id}`
    );
    return response.data;
  },

  workshopFotolariDetay: async (workshopId: string) => {
    const response = await api.get<ApiResponse<WorkshopFoto[]>>(
      `/api/BirlikteGuzellestirelim/WorkshopFotolari/Detay/${workshopId}`
    );
    return response.data;
  },

  workshopFotoEkle: async (data: WorkshopFotoCreateDTO) => {
    const formData = new FormData();
    formData.append("sira", data.sira.toString());
    formData.append("workshopId", data.workshopId);
    formData.append("foto", data.foto);

    const response = await api.post<ApiResponse<WorkshopFoto>>(
      "/api/BirlikteGuzellestirelim/WorkshopFotolari/Ekle",
      formData,
      {
        headers: { "Content-Type": "multipart/form-data" },
      }
    );
    return response.data;
  },

  workshopFotoSil: async (id: string) => {
    const response = await api.delete<ApiResponse<boolean>>(
      `/api/BirlikteGuzellestirelim/WorkshopFotolariSil/${id}`
    );
    return response.data;
  },
};
